interface Config {
    apiBaseUrl: string;
    endpoints: {
        personalTaskSearch: string;
        amountPersonalTasks: string;
        countOfTasksByProcess: string;
        taskDetails: string;
    };
    urls: {
        sistemasTaskUrl: string;
        vuiTaskUrl: string;
    }
}

const config: Config = {
    apiBaseUrl: process.env.VUE_APP_TASK_API || '',
    endpoints: {
        personalTaskSearch: '/GetSistemasTasks',
        amountPersonalTasks: '/GetAmountOfSistemasTask',
        countOfTasksByProcess: '/GetAmountOfSistemasTaskByProcess',
        taskDetails: '/GetTaskDetail'
    },
    urls: {
        sistemasTaskUrl: process.env.VUE_APP_SISTEMAS_TASK_URL,
        vuiTaskUrl: 'https://des.vui.cr/BPM_TareaPersonal.aspx'
    }
}

export default config; 